/* @flow */
import * as React from 'react';

import Profile from 'components/Profile';
import Group from 'entities/Group';
import Message from 'entities/Message';
import AnnouncementMessageListItem from 'chat/components/AnnouncementMessageListItem';
import GroupProfileHeader from 'groups/components/GroupProfileHeader';

import './PeopleListViewAllAnnouncements.scss';

import type { ClassProfile_classes } from 'groups/queries/__generated__/ClassProfile';

type Props = {
  group: ClassProfile_classes,
  onBackClicked?: () => void,
  onClose: () => void,
};

export default class PeopleListViewAllAnnouncements extends React.Component<Props> {
  getSections = () => {
    const { group } = this.props;
    const { broadcastCompositeStream } = group;

    const groupEntity = ((Group.fromJSON(group): any): Group);

    if (broadcastCompositeStream) {
      const messages = broadcastCompositeStream.map(m => Message.fromJSON(m));

      return [
        {
          children: this.renderBroadcastList(messages, groupEntity),
          collapsible: false,
        },
      ];
    }

    return [];
  };

  renderBroadcastList = (messages: Message[], groupEntity: Group) => {
    if (messages) {
      return (
        <ul>
          <AnnouncementMessageListItem
            messages={messages}
            group={groupEntity}
            isGroupChat={false}
            disableReactionToggle={false}
            showProfilePic={false}
            showMetadata
          />
        </ul>
      );
    }

    return null;
  };

  render() {
    const { group, onClose, onBackClicked } = this.props;

    return (
      <Profile
        header={<GroupProfileHeader group={group} subtext="Recent announcements" />}
        sections={this.getSections()}
        onBackClicked={onBackClicked}
        onClose={onClose}
        className="PeopleListViewAllAnnouncements"
      />
    );
  }
}
